import { atom, getDefaultStore, useAtom } from 'jotai';

import { ScoreDisplay } from '../types';

export const resultsScoreDisplayAtom = atom<ScoreDisplay>(
  ScoreDisplay.ProgressPercent
);
export const reportsScoreDisplayAtom = atom<ScoreDisplay>(
  ScoreDisplay.ScorePercent
);

export const useResultsScoreDisplay = () => useAtom(resultsScoreDisplayAtom);

export const useReportsScoreDisplay = () => useAtom(reportsScoreDisplayAtom);

export function useScoreDisplay(isActivityInProgress: boolean) {
  const resultsScoreDisplay = useResultsScoreDisplay();
  const reportsScoreDisplay = useReportsScoreDisplay();

  return isActivityInProgress ? resultsScoreDisplay : reportsScoreDisplay;
}

export function resetScoreDisplay() {
  const store = getDefaultStore();
  store.set(resultsScoreDisplayAtom, ScoreDisplay.ProgressPercent);
  store.set(reportsScoreDisplayAtom, ScoreDisplay.ScorePercent);
}
